import { createSlice } from '@reduxjs/toolkit';

import { CategoriesProgress } from '../../../core/interfaces/ICategories';
import { CategoriesReducer } from '../../reducers/CategoriesReducer';

const initialState: CategoriesProgress = {
	categories: [],
};

export const categoriesSlice = createSlice({
	name: 'categories',
	initialState,
	reducers: CategoriesReducer,
});

export const { setInitial } = categoriesSlice.actions;

export default categoriesSlice.reducer;
